import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { FieldArray } from 'redux-form';
import InputLabel from "../../../components/core/input/InputLabel";
import ClauseRow from "../ClauseRow";
import { _ClauseGroupWrapper, _OrButton } from "./style";
import { _InputWrapperDiv } from "../../../components/core/input/inputStyles";
var ClauseGroup = function ClauseGroup(_ref) {
  var apiConditionResourcesAttributes = _ref.apiConditionResourcesAttributes,
    conditionResourcesOptions = _ref.conditionResourcesOptions,
    conditionModalVisible = _ref.conditionModalVisible,
    disabledUpdateCondition = _ref.disabledUpdateCondition,
    fields = _ref.fields,
    _handleAddAndClause = _ref.handleAddAndClause,
    handleAddOrClause = _ref.handleAddOrClause,
    handleDeleteClauseGroup = _ref.handleDeleteClauseGroup,
    _ref$meta = _ref.meta,
    error = _ref$meta.error,
    submitFailed = _ref$meta.submitFailed,
    setLoading = _ref.setLoading;
  return /*#__PURE__*/React.createElement("div", {
    css: "margin-top: 5px"
  }, submitFailed && error && /*#__PURE__*/React.createElement("span", null, error), fields.map(function (clause, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(_ClauseGroupWrapper, {
      key: index,
      flexDirection: "column"
    }, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
      labelText: "Clause Group",
      required: true,
      subLabel: "All clauses in this group must be satisfied",
      deleteLabel: fields.length > 1 && fields.length === index + 1 && !disabledUpdateCondition ? handleDeleteClauseGroup : null,
      index: index
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FieldArray, {
      apiConditionResourcesAttributes: apiConditionResourcesAttributes,
      component: ClauseRow,
      conditionResourcesOptions: conditionResourcesOptions,
      conditionModalVisible: conditionModalVisible,
      disabledUpdateCondition: disabledUpdateCondition,
      handleAddAndClause: function handleAddAndClause() {
        return _handleAddAndClause(index);
      },
      name: "".concat(clause, ".clauses"),
      setLoading: setLoading
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(_OrButton, {
      disabled: disabledUpdateCondition,
      onClick: function onClick() {
        return disabledUpdateCondition ? null : handleAddOrClause();
      }
    }, "OR"))));
  }));
};
export default ClauseGroup;